@switch (columnName) {
  @case ('dateTime') {
    {{ element['date'] | date: dateFormat }}
  }
  @case ('action') {
    {{ element['drillVersionReason'] | lowercase | translate }}
  }
  @case ('actionDoneBy') {
    <div class="row align-items-center">
      <mat-icon>perm_identity</mat-icon>
      <p class="text">{{ element['by'] }}</p>
    </div>
  }
  @case ('comment') {
    @if (element.drillVersionReason === drillActionTypes.Perform) {
      {{ 'performedWithXParticipants' | translate: { participantsCount: element['details'] } }}
    }
    @if (element.drillVersionReason === drillActionTypes.Postpone) {
      <div class="column">
        <p>
          {{ 'postponed' | translate }}
          @if (element?.details?.oldValue) {
            &nbsp;{{ 'from' | translate | lowercase }}
          }
          {{ element?.details?.oldValue | date }}
          @if (element?.details?.newValue) {
            &nbsp;{{ 'to' | translate | lowercase }}
          }
          {{ element?.details?.newValue | date }}
        </p>
        <p>{{ element?.details?.comment }}</p>
      </div>
    }
  }
  @case ('view') {
    @if (element.drillVersionReason === drillActionTypes.Perform) {
      <app-ui-button
        buttonType="secondary"
        text="{{ 'view' | translate }}"
        [routerLink]="performViewRoute + '/' + element['drillId'] + '/' + element['drillVersionId']"
      ></app-ui-button>
    }
  }
  @case ('legacyAttachment') {
    @if (element.attachment) {
      @if (element.attachment.id !== 'new') {
        <a [href]="element.attachment.link" target="_blank" [download]="element.attachment.name">
          <mat-icon class="download-icon">download</mat-icon>
        </a>
      }
    }
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
